import Mobile from "./Mobile";
import Web from "./Web"
import Dimension from "./Dimension";

function Chatbot() {
const { height, width } = Dimension();
const ratio = height/width
return(
  <>
  <div id='credo-chatbot' style={{ position: 'fixed', top: 0, paddingLeft:2000 }}>
  {ratio<0.75?<Web/>:<Mobile/>}
  </div>
  </>
)
}

export default Chatbot;